export class Pedido {
  constructor(data = {}) {
    this.idContaAcessoCancelamento = data.idContaAcessoCancelamento || null;
    this.numeroPedido = data.numeroPedido || 0;
    this.idMotivoCancelamentoPedido = data.idMotivoCancelamentoPedido || 0;
  }
}
